import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from '@account/usuario.service';
import { MessageService } from '@shell/message.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { EstadoNotificacion } from "@shared/enums/EstadoNotificacion";
import { CustomValidatorsService } from "@shared/validators/custom-validators.service";
import { SaldoCliente } from "@shared/models/controlCredito/SaldoCliente";
import { NotificacionSaldo } from "@shared/models/controlCredito/NotificacionSaldo";
import { isEmptyValue } from "@shared/compat-tools";
import { Guid } from "guid-typescript";

@Component({
  selector: 'app-modal-crear-notificacion',
  templateUrl: './modal-crear-notificacion.component.html',
  styleUrls: ['./modal-crear-notificacion.component.scss']
})
export class ModalCrearNotificacionComponent implements OnInit {

  @Input() cliente: SaldoCliente;
  @Input() idNotificacionSaldos: string;
  @Input() estadoNotificaciones: EstadoNotificacion;
  @Input() index;
  crearNotificacionForm: FormGroup;
  mailsNotificacion: string[] = [];
  mailExiste: boolean = false;
  notificacionDeEnvio: NotificacionSaldo;
  monto: string;
  grabando: boolean = false;
  TipoUsuario = TipoUsuario;
  enumEstadoNotificacion = EstadoNotificacion;
  titulo: string = "";

  constructor(private formBuilder:FormBuilder, public authService: AuthService, public activeModal: NgbActiveModal,
              public messageService: MessageService,private controlCreditoService: ControlCreditoService,
              private usuarioService: UsuarioService) { }

  ngOnInit(): void {
    this.crearFormulario();
    this.cargarTitulo();
  }

  crearFormulario() {
    this.crearNotificacionForm = this.formBuilder.group({
      emailFormControl: ['', CustomValidatorsService.emailValidator],
      montoFormControl: [0],
      mensajeFormControl: ['']
    });
  }

  configurarValidacion(): void {
    if (this.estadoNotificaciones === EstadoNotificacion.previoAlExcedido) {
      this.mensajeFormControl.clearValidators();
      this.montoFormControl.setValidators([Validators.required, Validators.min(0)])
    } else {
      this.mensajeFormControl.setValidators([Validators.required, Validators.maxLength(255)]);
      this.montoFormControl.clearValidators();
    }
    this.mensajeFormControl.updateValueAndValidity();
    this.montoFormControl.updateValueAndValidity();
  }

  cargarTitulo(){
    if (this.estadoNotificaciones === EstadoNotificacion.previoAlExcedido)
        this.titulo = "Cliente previo al excedido";
    else if (this.estadoNotificaciones === EstadoNotificacion.saldoVencido)
        this.titulo = "Cliente saldo vencido";
    else
      this.titulo = "Cliente saldo excedido";
  }

  agregarMonto(): void {
    const filtros = this.cliente?.notificacionSaldo?.filtrosSeleccionados || [];
    this.monto = filtros.find(filtro =>
      filtro.clave?.toLowerCase().trim() === 'monto'
    )?.valor || '';
    this.montoFormControl.setValue(this.monto);
    console.log('monto: ' + JSON.stringify(this.monto));
  }

  agregarMails(enumNotificaciones: EstadoNotificacion): void {
    if (enumNotificaciones === EstadoNotificacion.previoAlExcedido) {
      this.mailsNotificacion = this.cliente.notificacionSaldo?.emails.map(mail => mail) ?? [];
    } else if (enumNotificaciones === EstadoNotificacion.saldoVencido) {
      this.mailsNotificacion = this.cliente.notificacionVencido?.destinatarios.split(',') ?? [];
    } else {
      this.mailsNotificacion = this.cliente.notificacionExcedido?.destinatarios.split(',') ?? [];
    }
  }

  agregarNotificacion() {
    this.grabando = true;
    if(this.mailsNotificacion.length > 0 && this.estadoNotificaciones === EstadoNotificacion.previoAlExcedido) {
      const notificacion = {
        "Activo": true,
        "Emails": this.mailsNotificacion,
        "TipoEstadoNotificacion": this.estadoNotificaciones,
        "TipoNovedad": {
          "Id": this.idNotificacionSaldos,
          "Descripcion": "Saldos"
        },
        "Mensaje":
          "El cliente " + this.cliente.clienteRazonSocial + " supero el monto asignado de " + this.montoFormControl.value,
        "Titulo": this.titulo,
        "Usuarios": [{
          "Id": this.usuarioService.getIdUsuario(),
          "NombresCompleto": this.usuarioService.getNombresCompletosUsuario(),
          "DNI": this.usuarioService.getDniUsuario(),
          "Email": this.usuarioService.getEmailUsuario()
        }],
        "FiltrosSeleccionados": [{
          "Id": this.cliente.notificacionSaldo ? this.cliente.notificacionSaldo.filtrosSeleccionados.find(filtro => filtro.clave === 'ClienteId').id : Guid.EMPTY,
          "Clave": "ClienteId",
          "Valor": this.cliente.clienteId,
          "OperadorLogico": 0,
          "Activo": true
        },
        {
          "Clave": "Monto",
          "Valor": this.montoFormControl.value?.toString(),
          "OperadorLogico": 2,
          "Activo": true
        }]
      }
      if (isEmptyValue(this.cliente.notificacionSaldo)) {
        this.controlCreditoService.crearNotificacion(notificacion).subscribe(notificacion => {
          this.cliente.notificacionSaldo = notificacion;
          notificacion.filtrosSeleccionados.forEach(filtro => {
            if(filtro.clave === "Monto") this.monto = filtro.valor;
            this.grabando = false;
            this.activeModal.close(false);
          })
        }, (err: ErrorModel) => {
          this.messageService.showErrorMessage('Hubo un error al crear la notificación: ' + err.description);
          this.grabando = false;
          this.activeModal.close(false);
        });
      } else {
        this.controlCreditoService.actualizarNotificacion(notificacion, this.cliente.notificacionSaldo.id).subscribe(notificacion => {
          this.cliente.notificacionSaldo = notificacion;
          notificacion.filtrosSeleccionados.forEach(filtro => {
            if(filtro.clave === "Monto") this.monto = filtro.valor;
            this.grabando = false;
            this.activeModal.close(false);
          })
        }, (err: ErrorModel) => {
          this.messageService.showErrorMessage('Hubo un error al actualizar la notificación: ' + err.description);
          this.grabando = false;
          this.activeModal.close(false);
        });
      }
    } else if(this.mailsNotificacion.length > 0 && this.estadoNotificaciones !== EstadoNotificacion.previoAlExcedido) {
      this.notificacionDeEnvio = new NotificacionSaldo();
      this.notificacionDeEnvio.mensaje = this.mensajeFormControl.value;
      this.notificacionDeEnvio.destinatarios = this.mailsNotificacion.join(',');
      this.controlCreditoService.crearNotificacionSaldos(this.cliente.clienteId, this.estadoNotificaciones, this.notificacionDeEnvio).subscribe(() => {
        this.messageService.showSuccessMessage('Notificación creada correctamente');
        if (this.estadoNotificaciones === EstadoNotificacion.saldoVencido) {
          this.cliente.notificacionVencido = new NotificacionSaldo();
          this.cliente.notificacionVencido.mensaje = this.mensajeFormControl.value;
          this.cliente.notificacionVencido.destinatarios = this.notificacionDeEnvio.destinatarios;
        } else {
          this.cliente.notificacionExcedido = new NotificacionSaldo();
          this.cliente.notificacionExcedido.mensaje = this.mensajeFormControl.value;
          this.cliente.notificacionExcedido.destinatarios = this.notificacionDeEnvio.destinatarios;
        }
        this.grabando = false;
        this.activeModal.close(false);
      }, (err: ErrorModel) => {
        this.messageService.showErrorMessage('Hubo un error al crear la notificación. ' + err.description);
        this.grabando = false;
        this.activeModal.close(false);
      })
    }
  }

  borrarMail(i) {
    this.mailsNotificacion.splice(i, 1)
  }

  agregarMail() {
    this.mailExiste = !!this.mailsNotificacion.find((mail) => this.emailFormControl?.value === mail);
    if(!this.emailFormControl?.errors?.email && this.emailFormControl.value && !this.mailExiste) {
      this.mailsNotificacion.push(this.emailFormControl.value);
      this.emailFormControl.setValue('');
    }
  }

  saldoExcedidoNotificacion(){
    this.estadoNotificaciones = this.enumEstadoNotificacion.saldoExcedido;
    this.configurarValidacion();
    this.agregarMails(this.estadoNotificaciones);
    this.mensajeFormControl.setValue(this.cliente.notificacionExcedido?.mensaje ?? '')
  }

  saldoVencidoNotificacion(){
    this.estadoNotificaciones = this.enumEstadoNotificacion.saldoVencido;
    this.configurarValidacion();
    this.agregarMails(this.estadoNotificaciones);
    this.mensajeFormControl.setValue(this.cliente.notificacionVencido?.mensaje ?? '')
  }

  previoAlExcedidoNotificacion(){
    this.estadoNotificaciones = this.enumEstadoNotificacion.previoAlExcedido;
    this.configurarValidacion();
    this.agregarMonto();
    this.agregarMails(this.estadoNotificaciones);
  }

  mensajeVacio(): boolean{
    if (this.estadoNotificaciones !== this.enumEstadoNotificacion.previoAlExcedido) {
      return !(this.mensajeFormControl.value.trim().length > 0);
    }
    return false;
  }
  /** getters */
  get emailFormControl() {
    return this.crearNotificacionForm.get('emailFormControl');
  }

  get montoFormControl() {
    return this.crearNotificacionForm.get('montoFormControl');
  }

  get mensajeFormControl(){
    return this.crearNotificacionForm.get('mensajeFormControl');
  }
}
